<script>
export default {
  name: "EvaluationItem",
  props:{
    evaluation: Object,
  isView:{
    type: Boolean,
    default(){
      return false
    }
  },
  isEntrance: {
    type: Boolean,
    default: false
  }
  },
  data(){
    return {
      itemOfEvaluation: null,
      dialogVisible: false
    }
  },
  methods:{
    handleScoreChange(evaluationItem){
      const match = evaluationItem.items.find((i) => i.score === evaluationItem.criterion_score)
      evaluationItem.comment_auto = match?.comment ?? ''
      evaluationItem.e_comment_auto = match?.eComment ?? ''
    },
    displayBarem(evaluationItem){
      this.itemOfEvaluation = evaluationItem
      this.dialogVisible = true
    },
    selectBarem(score,comment, eComment){
      this.itemOfEvaluation.comment_auto = comment
      this.itemOfEvaluation.criterion_score = score
      this.itemOfEvaluation.e_comment_auto = eComment || comment
      this.dialogVisible = false
    }
  }
}
</script>

<template>
  <div >
    <div class="marking-box" v-for="(evaluationItem,evaluationItemIndex) in evaluation?.items" :key="evaluationItem.label">
      <div class="d-flex justify-content-between">
        <div class="section-title" v-if="evaluationItem?.label">
          {{evaluationItem?.label}}
        </div>
        <div v-else>
        </div>
        <div class="button-right">
          <el-button type="primary" size="small" @click="displayBarem(evaluationItem)" :disabled="isView || (!isEntrance && evaluationItem?.disable)">Chấm theo barem</el-button>
        </div>
      </div>
      <div class="form-group">
        <label>Điểm tiêu chí:</label>
        <el-select v-model="evaluationItem.criterion_score"  placeholder="Chọn điểm" size="small" @change="handleScoreChange(evaluationItem)" :disabled="isView || (!isEntrance && evaluationItem?.disable)">
          <el-option v-for="item in evaluationItem.items" :key="`${evaluationItemIndex}${item.comment}`" :label="item.score" :value="item.score" />
        </el-select>
      </div>

      <div class="form-group">
        <label>Nhận xét tự động:</label>
          <el-input
            :disabled="true" type="textarea"
            style="border-radius: 4px; border: 1px solid lightgray; padding: 6px; min-height: 90px"
            :value="evaluationItem.e_comment_auto || evaluationItem.comment_auto"
            placeholder="Tự động điền nhận xét ở đây"
            :autosize="{ minRows: 2, maxRows: 4 }"
        />
      </div>
    </div>
    <el-dialog
      :title="`Barem chấm điểm ${itemOfEvaluation?.label}`"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <el-table
       :data="itemOfEvaluation?.items"
       border
       style="width: 100%; max-height: 500px; overflow-y: auto"
      >
        <el-table-column label="Lời nhận xét" prop="comment">
          <template slot-scope="scope">
            <div  :style="{
              color: itemOfEvaluation.comment_auto === scope?.row?.eComment ? '#409EFF' : 'inherit',
              fontWeight: itemOfEvaluation.comment_auto === scope?.row?.eComment ? 'bold' : 'normal'
            }" style="white-space: pre-line; word-break: break-word" v-html="scope?.row?.eComment ||scope?.row?.comment ">
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Hành động" width="120px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="selectBarem(scope?.row?.score, scope?.row?.Comment,scope?.row?.eComment)"
            >
              Chọn
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>

<style scoped>
.marking-box {
  border: 1px solid #e0e0e0;
  padding: 16px;
  border-radius: 6px;
  background-color: #fafafa;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.section-title {
  background-color: #f56c6c;
  color: white;
  display: inline-block;
  padding: 4px 12px;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.form-group {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

.button-right {
  text-align: right;
}

.auto-comment {
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid lightgray;
  padding: 6px;
  min-height: 90px;
  line-height: 1.5;
  font-size: 14px;
  font-family: inherit;
  color: #606266;
  background-color: #f5f7fa;
  cursor: not-allowed;
  word-break: break-word;
  white-space: pre-line;
  overflow-y: auto;
}

.auto-comment.placeholder {
  color: #c0c4cc;
}

.auto-comment-input >>> textarea {
  min-height: 90px;
}
</style>
